import React from "react";
import FilterList from "../Components/CollectionsFilterPanel/CollectionsFilterPanel";
import TitleSearch from "../Components/TitleSearch/TitleSearch";
import { Layout } from "antd";
import SinglePage from "../Components/SinglePage/SinglePage";
import { useEffect, useState } from "react";
import { setLogin } from "../Slices/UserActions";
import { useDispatch, useSelector } from "react-redux";
import AuthorPage from "../Components/AuthorPage/AuthorPage";
import { RouterProvider, createBrowserRouter, useLocation } from "react-router-dom";
import { removeLastWindowNHQ } from "../Slices/WindowNHQSlice";
import PublicCollectionsPage from "./PublicCollectionsPage/PublicCollectionsPage";

type Props = {};

const Main = (props: Props) => {
  const dispatch = useDispatch();
  const content = useSelector((state: any) => state.windowNHQ.content)
  // const [last, setLast] = useState<any>({
  //   prev: null,
  //   current: null
  // });


  useEffect(() => {
    if (
      (typeof (window as any).NHQ?.token !== "undefined" &&
        (window as any).NHQ?.token !== "" &&
        (window as any).NHQ?.token !== null) ||
      process.env.REACT_APP_AUTH_TOKEN
    ) {
      dispatch(setLogin(true));
    } else {
      dispatch(setLogin(false));
    }
  }, []);

  const router: any = createBrowserRouter([
    {
      path: "/collections",
      element: <PublicCollectionsPage />
    },
    {
      path: "/category/:category",
      element: <PublicCollectionsPage />
    },
    {
      path: "/tag/:tag",
      element: <PublicCollectionsPage />
    },
    {
      path: "/collection/:title",
      element: <SinglePage />,
    },
    {
      path: "/collection/p/*",
      element: <SinglePage />,
    },
    {
      path: "/author/:name",
      element: <AuthorPage />,
    },
  ]);

  // useEffect(()=>{
  //   console.log(content, 'WINDOW CONTENT')
  //   console.log(window.location.pathname, 'WINDOW PATHNAME')
  // }, [content, window.location.pathname])

  // useEffect(() => {
  //   window.addEventListener("popstate", function (event: any) {
  //     console.log("Back or Forward button pressed");
  //     alert(event.state.idx)
  //     setLast((pre:any) =>  (
  //       {
  //         ...pre,
  //         prev: pre.current,
  //         current: event.state.idx
  //       }
  //     ))
  //   });

  //   // return () => window.removeEventListener('popstate', function (event: any) {
  //   //   console.log("Back or Forward button pressed");
  //   //   alert(event.state.idx)
  //   //   setLast(prev => prev > event.state.idx ? event.state.idx : prev);
  //   // })
  // }, []);

  // useEffect(()=>{
  //   setLast((pre:any) =>  (
  //     {
  //       ...pre,
  //       prev: pre.current,
  //       current: window.history.state.idx
  //     }
  //   ))

  //   console.log("LAST SETTED")
  
  // }, [window.location.pathname])

  // useEffect(() => {
  //   console.log(last, "LAST DEVANG");

  //   if(last?.prev > last.current){
  //     dispatch(removeLastWindowNHQ())

  //     console.log("LAST BACKWARD")
  //   }

  //   else {
  //     console.log("LAST FORWARD")
  //   }
  // }, [last]);


  return (
    <>
      <Layout
        className="main"
        style={{ maxWidth: "1600px", margin: "auto", backgroundColor: "white" }}
      >
        <RouterProvider router={router} />
      </Layout>
    </>
  );
};

export default Main;
